<template>
  <div class="block gzwm" id="gzwm">
    <div class="itemTitBox wow animated bounceInRight">
      <p class="big">关注我们</p>
      <p class="small">FOLLOW US</p>
    </div>
    <div class="zwsq">
      <div class="textBox wow animated bounceInLeft">
        <p class="txt">PG中文社区</p>
        <p class="btn" @click="go">点击进入</p>
      </div>
      <img class="code wow animated flipInY" src="../assets/images/180x180.png" alt="">
      <img class="code wow animated bounceInRight" src="../assets/images/180x180-2.png" alt="">
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    go() {
      window.open('https://postgres.fun/')
    }
  }
}
</script>
<style lang="less" scoped>
.gzwm {
  margin-top: 50px;
}
.zwsq {
  margin: 0 auto;
  margin-top: 31px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 514px;
  height: 157px;
  background: url("../assets/images/1558x877.png") no-repeat;
  background-size: 100% 100%;
  transition: all 0.6s;
  &:hover{
    transform: scale(1.05);
  }
  .code {
    width: 90px;
    height: 90px;
  }
  .textBox {
    width: 150px;
    text-align: center;
    .txt {
      font-size: 25px;
      font-family: MicrosoftYaHei;
      font-weight: bold;
      color: #FFFFFF;
    }
    .btn {
      margin: 0 auto;
      margin-top: 13px;
      width: 146px;
      height: 29px;
      background: #062A85;
      border: 1px solid #00FFFC;
      border-radius: 14px;
      font-size: 17px;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      color: #00FFFC;
      text-align: center;
      line-height: 30px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/gzwm.vue